import { apiPost } from './ApiRequest'

export const createSubscriptionTracking = async (origin) => {
	const response = await apiPost({ origin }, 'tracking/subscriptions')
	if (response?.ok !== true) return null

	const tracking = await response.json()
	return tracking
}
